import gql from "graphql-tag"
import IngestionSourceFragment from "../fragment/IngestionSourceFragment"

export default gql`
  ${IngestionSourceFragment}
  query ingestionSourceList {
    ingestionSourceList {
      ...IngestionSourceFragment
    }
  }
`
